"use client";

import countryCodes from "../../helpers/countryCodes";
import { registerRbcomFooter } from "@rbup/ges-smart-web-components";
import { useEffect, useLayoutEffect } from "react";

/**
 * This RbFooter component implements the instructions in the Red Bull Platforms
 * documentation. You can read more about that here:
 * @see {@link https://build.redbull.com/smart-components/rbcom-footer/getting-started}
 */

export const RbFooter = ({ localeString }: { localeString: string }) => {
  const locale = countryCodes.available.includes(localeString)
    ? localeString
    : countryCodes.fallback;

  useEffect(() => {
    window.addEventListener("cookiesettingsclick", () =>
      window.Optanon?.ToggleInfoDisplay(),
    );
  }, [locale]);

  useLayoutEffect(() => {
    registerRbcomFooter();
  }, []);

  return (
    <div>
      <rbcom-footer locale={locale} />
    </div>
  );
};
